<template>
  <vx-card no-shadow>
    <vs-breadcrumb class="mt-2">
      <li><router-link to="/wall">Wall</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li aria-current="page" class="active">Edit Wall Post</li>
    </vs-breadcrumb>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-2/5 w-full">
        <h2>Wall Post</h2>
      </div>
    </div>

    <div v-if="newsPost">
      <div class="vx-row mb-6" v-if="isPosted === true">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Active</span>
        </div>
        <div class="vx-col">
          <vs-switch color="success" v-if="newsPost" v-model="newsPost.active" />
        </div>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <i8n-input v-if="newsPost" label="" :content.sync="newsPost.title" class="w-full" />
      </div>
    </div>

    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Content</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <i8n-textarea-mention v-if="newsPost" placeholder="Content..." :content.sync="newsPost.content" :mentions="mentions" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-row">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Availability</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full" style="display: flex">
        <div class="my-4">
          <small class="date-label">Available from</small>
          <flat-pickr
            v-if="newsPost"
            :config="configdateStartTimePicker"
            v-model="startDate"
            placeholder="Start..."
            style="display: flex"
          />
        </div>

        <div class="my-4" style="margin-left: 8px">
          <small class="date-label">Available until</small>
          <flat-pickr
            v-if="newsPost"
            :disabled="!newsPost.hasEndAvailability"
            :config="configdateEndTimePicker"
            v-model="endDate"
            placeholder="End..."
            style="display: flex"
          />
          <vs-checkbox v-if="newsPost" v-model="newsPost.hasEndAvailability" class="mt-2">End availability?</vs-checkbox>
        </div>
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Tags (optional)</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips v-if="newsPost" placeholder="New Tag" v-model="newsPost.permTags" style="width: 100%">
          <vs-chip color="#24c1a0" :key="tag" @click="removeTag(tag)" v-for="tag in newsPost.permTags" closable>
            {{ tag }}
          </vs-chip>
        </vs-chips>
        <!--        <p style="font-weight: 600; font-size: 85%; margin-top: 8px">
          User will see the Wall Post when the country tag and at least one
          other tag matches the user tags.
        </p>-->
      </div>
    </div>

    <vs-divider />

    <!-- IdamSegmentator section - Audience segmentation -->
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Segmentation (who can see)</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <IdamSegmentator v-model="newsPost.userQuery" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col lg:w-1/1 w-full">
        <h5>Author</h5>
      </div>
    </div>

    <!--
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Post as REKOM</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="newsPost" :disabled="newsPost.author.postAsVenue" v-model="newsPost.author.postAsRekom"/>
      </div>
    </div>
-->

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Post as Venue</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-if="newsPost" :disabled="newsPost.author.postAsRekom" v-model="newsPost.author.postAsVenue" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue</span>
      </div>
      <div class="vx-col">
        <vs-dropdown
          v-if="newsPost"
          :disabled="!newsPost.author.postAsVenue"
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span v-if="selectedVenue">{{ selectedVenue.name }}</span>
            <span v-else>Select Venue</span>

            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item v-for="(venue, index) in venues" :key="index" @click="selectedVenue = venue">
              <span>{{ venue.name }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <vs-divider />

    <div class="vx-row mb-6">
      <div class="vx-col lg:w-1/1 w-full">
        <h5>Photos &amp; Videos</h5>
        <NewsPostImages v-if="newsPost" :news-post="newsPost" style="width: 100%" />
      </div>
    </div>
    <!--
    <div class="vx-row mb-6">
      <div class="vx-col lg:w-1/1 w-full">
        <h5>Other Files</h5>
        <NewsPostFiles v-if="newsPost" :newsPost="newsPost" style="width: 100%;" />
      </div>
    </div>-->

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="confirmDelete" id="delete-button" color="danger" class="ml-auto mt-2">Delete</vs-button>
      <vs-button @click="post" id="post-button" color="success" class="ml-4 mt-2">{{ isPosted ? "Re-notify" : "Post" }}</vs-button>
      <vs-button v-if="isPosted" @click="saveInfo(true)" id="move-to-top-button" color="success" class="ml-4 mt-2">Move to top</vs-button>
      <vs-button @click="saveInfo(false)" id="save-button" class="ml-4 mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TypeAhead from "vue2-typeahead";
import IdamSegmentator from "@/components/Custom/IdamSegmentator/IdamSegmentator";

const NewsPostImages = () => import("./components/NewsPostImages.vue");
const NewsPostFiles = () => import("./components/NewsPostFiles.vue");

export default {
  components: {
    flatPickr,
    TypeAhead,
    NewsPostImages,
    NewsPostFiles,
    IdamSegmentator
  },
  props: {},
  data() {
    let ctx = this;

    return {
      newsPost: null,
      isPosted: false,
      mentions: [],
      venues: [],
      selectedVenue: null,

      configdateStartTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateStartDate(selectedDates[0]);
        }
      },
      configdateEndTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y H:i",
        defaultHour: 20,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          if (selectedDates.length === 0) {
            return;
          }

          ctx.updateEndDate(selectedDates[0]);
        }
      },

      startDate: null,
      localStartDate: null,
      endDate: null,
      localEndDate: null
    };
  },
  methods: {
    removeTag(item) {
      this.newsPost.permTags.splice(this.newsPost.permTags.indexOf(item), 1);
    },
    updateStartDate: function (date) {
      this.localStartDate = new Date(date);
    },
    updateEndDate: function (date) {
      this.localEndDate = new Date(date);
    },

    getNewsPost: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/News/" + this.wallPostId;

      this.$http
        .get(url)
        .then(resp => {
          console.log("News Post:", resp.data);
          this.newsPost = resp.data.newsPost;
          this.isPosted = this.newsPost.isPosted;
          this.mentions = resp.data.mentions;
          this.venues = resp.data.venues;

          this.startDate = this.newsPost.startDate;
          this.endDate = this.newsPost.endDate;

          this.updateStartDate(this.newsPost.startDate);
          this.updateEndDate(this.newsPost.endDate);

          if (this.newsPost.postAsVenue && this.newsPost.author.venueId) {
            this.selectedVenue = this.venues.find(x => x.venueId === this.newsPost.author.venueId);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    confirmDelete() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete the News Post?",
        accept: this.deleteItem
      });
    },
    deleteItem() {
      const url = process.env.VUE_APP_API + "/News/" + this.newsPost.id;

      this.$http
        .delete(url)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "News Post deleted"
          });

          this.$router.push({ name: "admin-wall" }).catch(() => {});
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not delete News Post: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    post: function () {
      console.log("Posting...");

      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#post-button",
        scale: 0.45
      });

      this.$http
        .post(process.env.VUE_APP_API + "/News/" + this.newsPost.id)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "News Posted"
          });

          this.newsPost.active = true;
          this.isPosted = true;
        })
        .catch(err => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not post News: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close("#post-button > .con-vs-loading");
        });
    },

    saveInfo: function (moveToTop) {
      console.log("Saving News Post");

      if (!moveToTop) {
        this.$vs.loading({
          background: "primary",
          color: "#fff",
          container: "#save-button",
          scale: 0.45
        });
      } else {
        this.$vs.loading({
          background: "primary",
          color: "#fff",
          container: "#move-to-top-button",
          scale: 0.45
        });
      }

      const payload = {
        active: this.newsPost.active,
        title: this.newsPost.title,
        content: this.newsPost.content,
        tags: this.newsPost.permTags,
        postAsRekom: this.newsPost.author.postAsRekom,
        postAsVenue: this.newsPost.author.postAsVenue,
        venueId: this.newsPost.author.venueId,
        mentions: this.mentions,
        startDate: this.localStartDate,
        endDate: this.localEndDate,
        hasEndAvailability: this.newsPost.hasEndAvailability,
        moveToTop: moveToTop,
        userQuery: this.newsPost.userQuery
      };

      this.$http
        .put(process.env.VUE_APP_API + "/News/" + this.newsPost.id, payload)
        .then((/*resp*/) => {
          if (!moveToTop) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "News Post saved"
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "News Post moved to top"
            });
          }
        })
        .catch(err => {
          console.log(err);

          if (!moveToTop) {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not save News Post: " + err
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not move News Post to top: " + err
            });
          }
        })
        .finally(() => {
          if (!moveToTop) {
            this.$vs.loading.close("#save-button > .con-vs-loading");
          } else {
            this.$vs.loading.close("#move-to-top-button > .con-vs-loading");
          }
        });
    }
  },
  created() {
    this.wallPostId = this.$route.params.wallPostId;

    this.getNewsPost();
  }
};
</script>

<style lang="scss">
.con-chips--remove-all {
  display: none;
}

.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
</style>